import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/list_templates/${packing_house_id}/packing_house_process/${packing_house_process_id}`
    );
  },
  fetchQualityTemplateMainRep({
    packing_house_id,
    packing_house_process_id,
    quality_template_main_rep_id
  }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/show_template_main_rep/${packing_house_id}/${packing_house_process_id}/quality_template_main_rep/${quality_template_main_rep_id}`
    );
  },
  fetchProducers({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/show_template_main_rep/${packing_house_id}/${packing_house_process_id}/list_producers`
    );
  },
  fetchOrganizations({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/show_template_main_rep/${packing_house_id}/${packing_house_process_id}/list_organizations`
    );
  },

  downloadRepXlsx({
    packing_house_id,
    packing_house_process_id,
    quality_template_main_rep_id,
    search_params
  }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/show_template_main_rep/${packing_house_id}/${packing_house_process_id}/template_rep_xlsx/${quality_template_main_rep_id}/` +
        `search?producer=${search_params.producer}&organization=${search_params.organization}&registered_at=${search_params.registered_at}`,
      { responseType: "blob" }
    );
  },
  fetchRepGuiHeaders({
    packing_house_id,
    packing_house_process_id,
    quality_template_main_rep_id
  }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/show_template_main_rep/${packing_house_id}/${packing_house_process_id}/template_rep_gui_headers/${quality_template_main_rep_id}`
    );
  },
  fetchRepGuiData({
    packing_house_id,
    packing_house_process_id,
    quality_template_main_rep_id,
    search_params
  }) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/show_template_main_rep/${packing_house_id}/${packing_house_process_id}/template_rep_gui_data/${quality_template_main_rep_id}/` +
        `search?producer=${search_params.producer}&organization=${search_params.organization}&registered_at=${search_params.registered_at}`
    );
  }
};
